<form [formGroup]="form" (submit)="formSearchHandler()">
    <div class="row">
      <div class="col-sm-12 col-lg-4 form-group">        
        <label for="folio">Folio:</label>
        <input
            id="folio"
            name="folio"
            type="number"
            class="form-control"
            placeholder="folio de la revisión 123..."
            formControlName="folio"
          />
      </div>
      <div class="col-sm-12 col-lg-4 form-group">
        <label for="region">Región:</label>
          <select
            id="region"
            name="region"
            (change)="changeRegion($event)"
            class="form-control form-control-sm"
            formControlName="region"
          >
            <option value="0">Seleccione...</option>
            <option [value]="region.IdRegion" *ngFor="let region of regiones">
              {{ region.Nombre }}
            </option>
          </select>
      </div>
      <div class="col-sm-12 col-lg-4 form-group" [class.disable-seccion]="form.value.region == 0">
        <label for="estacion">{{ descriptionRegionSitio }}:</label>
        <select
          id="estacion"
          name="estacion"
          class="form-control form-control-sm"
          formControlName="estacion"
          [attr.tabindex]="form.value.region == 0 ? -1 : 0"
        >
          <option value="0">Todas</option>
          <option
            [value]="estacion.IdEstacion"
            *ngFor="let estacion of estaciones"
          >
            {{ estacion.Nombre }}
          </option>
        </select>
      </div>
    </div>
    <div class="row">      
      <div class="col-sm-12 col-lg-4 form-group">
        <label for="etapa">Etapa:</label>
        <select
          id="etapa"
          name="etapa"
          class="form-control form-control-sm"
          formControlName="etapa"
        >
          <option value="0">Todas</option>
          <option [value]="etapa.IdEtapa" *ngFor="let etapa of etapas">
            {{ etapa.Descripcion }}
          </option>
        </select>        
      </div>
      <div class="col-sm-12 col-lg-4 form-group">
        <label for="tipoRevision">Tipo de revision:</label>
        <select
          id="tipoRevision"
          name="tipoRevision"
          class="form-control form-control-sm"
          formControlName="tipoRevision"
        >
          <option value="0">Todas</option>
          <option
            [value]="tipoRevision.IdTipoRevision"
            *ngFor="let tipoRevision of tipoRevisiones"
          >
            {{ tipoRevision.Descripcion }}
          </option>
        </select>        
      </div>
      <div class="col-sm-12 col-lg-4 form-group">
        <label for="fechaInicioReal">Fecha inicio real:</label>
        <input
          id="fechaInicioReal"
          name="fechaInicioReal"
          type="date"
          class="form-control"
          formControlName="fechaInicioReal"
        />
      </div>
    </div>
    <div class="row">      
      <div class="col-sm-12 col-lg-4 form-group">
        <label for="fechaFinReal">Fecha fin real:</label>
          <input
            id="fechaFinReal"
            name="fechaFinReal"
            type="date"
            class="form-control"
            formControlName="fechaFinReal"
          />
      </div>
      <div class="col-sm-12 col-lg-4 form-group">
        <label for="fechaInicioPlan">Fecha inicio planeada:</label>
        <input
          id="fechaInicioPlan"
          name="fechaInicioPlan"
          type="date"
          class="form-control"
          formControlName="fechaInicioPlaneada"
        />
      </div>
      <div class="col-sm-12 col-lg-4 form-group">
        <label for="fechaFinPlan">Fecha fin planeada:</label>
        <input
          id="fechaFinPlan"
          name="fechaFinPlan"
          type="date"
          class="form-control"
          formControlName="fechaFinPlaneada"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex justify-content-end">
        <button [disabled]="!validForm()" class="btn btn-sm btn-primary" type="submit">
          <i class="fa fa-search"></i> Buscar
        </button>
      </div>
    </div>
  </form>
  